export default __webpack_public_path__ + "static/media/sunrise.16703704.png";